import { HierarchyData, HierarchyItem } from "../types/data";
import { DataManStateOptions } from "../types/state";

export const buildHierarchyData = (
  hierarchyData: any[],
  data: any[],
  options: DataManStateOptions
): HierarchyData => {
  const {
    hierarchyKey = "id",
    hierarchyParentKey = "parentId",
    hierarchyItemKey = "id"
  } = options;

  // Create a map to store items by their id
  const itemMap = new Map<string, HierarchyItem>();

  // Initialize the item map with all items
  hierarchyData.forEach((item) => {
    const id = item[hierarchyKey];
    const parentId = item[hierarchyParentKey] || null;

    itemMap.set(id, {
      ...item,
      id,
      parentId,
      children: [],
      items: data.filter((d) => d[hierarchyItemKey] === id)
    });
  });

  // Build the hierarchy by assigning children to their parents
  const hierarchy: HierarchyData = [];
  itemMap.forEach((item) => {
    if (item.parentId) {
      const parentItem = itemMap.get(item.parentId);
      if (parentItem) {
        parentItem.children.push(item);
      }
    } else {
      // If there is no parentId, it means this is a root item
      hierarchy.push(item);
    }
  });

  return hierarchy;
};
